import * as Yup from 'yup'

export const Schema = Yup.object().shape({
    first_name: Yup.string()
        .required(' نام الزامی می باشد')
        .min(2, 'نام نمی تواند کمتر از 2 کاراکتر باشد')
        .max(15, 'نام نمی تواند بیشتر از 15 کاراکتر باشد'),
    last_name: Yup.string()
        .required('نام خانوادگی الزامی می باشد')
        .min(2, 'نام خانوادگی نمی تواند کمتر از 2 کاراکتر باشد')
        .max(15, 'نام خانوادگی نمی تواند بیشتر از 15 کاراکتر باشد'),
})
export const initialValues = (profileData: IAuthProfileData | undefined) => {
    return {
        first_name: profileData?.first_name ? profileData?.first_name : '',
        last_name: profileData?.last_name ? profileData?.last_name : '',
        email: profileData?.email ? profileData?.email : '',
    }
}
